import { ExpenseReportsFiltersBody } from 'src/components/ExpenseReportsBox/ExpenseReportsBox'
import { RootState } from 'src/redux/createRootReducer'

/**
 * The download flow stores the user's selected filter set on the approver
 * full-paginated slice via SET_IS_DOWNLOAD_EXPENSE_REPORTS_PAID_POPUP_OPEN;
 * DownloadExpenseReports reads it back here. (The report list itself is served
 * by React Query; see src/queries/expenseReports.)
 */
export const selectExpenseReportsBodyFromState = (
  state: RootState,
): ExpenseReportsFiltersBody | undefined =>
  state.app.expenseReports.expensesAllReports.expenseReportsFullPaginatedData
    .selectedDownloadExpenseReports
